
export default {
  name: 'OurPrinciples',
  computed: {
    list() {
      return this.$t('our_principles')
    },
  },
}
